import { render, staticRenderFns } from "./Init.vue?vue&type=template&id=3987f214&"
import script from "./Init.vue?vue&type=script&lang=js&"
export * from "./Init.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports